<template>
  <main class="paris">
    <Menu />
    <hero />
    <sponsors />
    <agenda />
    <speakers />
    <presenters />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Menu from '@/components/paris/menu.vue';
import hero from '@/components/paris/hero.vue';
import agenda from '@/components/paris/agenda.vue';
import sponsors from '@/components/paris/sponsors.vue';
import speakers from '@/components/paris/speakers.vue';
import presenters from '@/components/paris/presenters.vue';

export default {
  name: 'Home',
  components: {
    Menu,
    hero,
    agenda,
    sponsors,
    presenters,
    speakers
  },
};
</script>

<style lang="scss" scoped>
  .paris {
    &#single-schedule {
      padding: 30px 0;
    }
  }
</style>